
import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight, Globe } from "lucide-react";

const CtaSection: React.FC = () => {
  return (
    <div className="py-16 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -bottom-16 -right-16 w-64 h-64 bg-brand-orange opacity-20 rounded-full mix-blend-multiply filter blur-3xl"></div>
        <div className="absolute -top-16 -left-16 w-64 h-64 bg-brand-teal opacity-20 rounded-full mix-blend-multiply filter blur-3xl"></div>
      </div>
      
      <div className="max-w-7xl mx-auto relative">
        <div className="bg-gradient-to-r from-brand-orange/10 to-brand-teal/10 backdrop-blur-sm rounded-2xl p-10 md:p-16 border border-border shadow-lg">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-foreground sm:text-4xl">
              Ready to spark your future?
            </h2>
            <p className="mt-4 text-lg text-muted-foreground">
              Join TeenVisor today and connect with mentors, discover opportunities, and explore career paths that match your passions.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
              <Button variant="outline" size="lg" className="font-medium" asChild>
                <Link to="/faq">Learn More About Us</Link>
              </Button>
              <Button variant="secondary" size="lg" className="font-medium" asChild>
                <a href="https://nas.io/teenvisor" target="_blank" rel="noopener noreferrer" className="flex items-center">
                  Join Our Community
                  <Globe className="ml-2 h-4 w-4" />
                </a>
              </Button>
            </div>
            <p className="mt-6 text-sm text-muted-foreground">
              Already a member? <Link to="/signin" className="text-brand-purple hover:underline">Sign in</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CtaSection;
